import { createFileRoute } from '@tanstack/react-router'
import { ExpenseList } from '@/views/expenses'

export const Route = createFileRoute('/_authenticated/expenses/')({
  component: ExpenseList,
})
